var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 29.041H9.33333C8.59695 29.041 8 29.5509 8 30.1799C8 30.8089 8.59695 31.3188 9.33333 31.3188H38.6667C39.403 31.3188 40 30.8089 40 30.1799C40 29.5509 39.403 29.041 38.6667 29.041Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 19.3613H9.33333C8.59695 19.3613 8 19.8712 8 20.5002C8 21.1292 8.59695 21.6391 9.33333 21.6391H38.6667C39.403 21.6391 40 21.1292 40 20.5002C40 19.8712 39.403 19.3613 38.6667 19.3613Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 9.68164H9.33333C8.59695 9.68164 8 10.1915 8 10.8205C8 11.4495 8.59695 11.9594 9.33333 11.9594H38.6667C39.403 11.9594 40 11.4495 40 10.8205C40 10.1915 39.403 9.68164 38.6667 9.68164Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.30ec425fc3ca5b7a147fc8ab6668f527.svg";
export { ForwardRef as ReactComponent };